import { rolesClient } from '@/helpers/api/apiClients'
import type { IRoleRepository } from './contracts/IRoleRepository'

/**
 * Role service - abstraction over roles API client.
 * Use this instead of importing rolesClient directly for better testability.
 */
export const roleService: IRoleRepository = {
	getList: (tenantId) => rolesClient.getList(tenantId),
	getById: (id, tenantId) => rolesClient.getById(id, tenantId),
	getByIdWithPermissions: (id, tenantId) => rolesClient.getByIdWithPermissions(id, tenantId),
	registerRole: (request, tenantId) => rolesClient.registerRole(tenantId, request),
	delete: (id, tenantId) => rolesClient.delete(id, tenantId),
	getAllPermissionList: (tenantId) => rolesClient.getAllPermissionList(tenantId),
	updatePermissions: (id, request, tenantId) => rolesClient.updatePermissions(id, tenantId, request),
}
